var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowButtonRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.577 8.612l-.675.675a1.5 1.5 0 00.135 2.085l8.1 8.1-8.235 8.19a1.365 1.365 0 000 1.935l.675.675a1.305 1.305 0 001.845.12l9.48-9.42.54-.42a1.303 1.303 0 00.45-.915 1.29 1.29 0 00-.405-.93l-.495-.48-9.39-9.48a1.5 1.5 0 00-2.025-.135z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 10,
    stroke: "#fff"
  })));
}
export default SvgArrowButtonRight;